import { render, staticRenderFns } from "./AdminTab.vue?vue&type=template&id=a75a6922&scoped=true&"
import script from "./AdminTab.vue?vue&type=script&lang=js&"
export * from "./AdminTab.vue?vue&type=script&lang=js&"
import style0 from "./AdminTab.vue?vue&type=style&index=0&id=a75a6922&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75a6922",
  null
  
)

export default component.exports